(() => {
  if (customElements.get('mp-type-grid')) return;

  let dateTimer;
  function updateShipDates() {
    clearTimeout(dateTimer);
    const now = new Date();
    const nextMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const shipBy = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 3);
    const iso = [shipBy.getFullYear(), String(shipBy.getMonth() + 1).padStart(2, '0'), String(shipBy.getDate()).padStart(2, '0')].join('-');
    const label = shipBy.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    for (const date of document.querySelectorAll('[data-mp-ship-date]')) {
      date.dateTime = iso;
      date.textContent = label;
    }
    dateTimer = setTimeout(updateShipDates, nextMidnight.getTime() - now.getTime() + 100);
  }
  updateShipDates();
  window.addEventListener('pageshow', updateShipDates);
  document.addEventListener('shopify:section:load', updateShipDates);

  function syncSelection(root) {
    const stock = root.querySelector('[data-mp-stock]');
    if (!stock) return;
    const picker = root.querySelector('variant-selects');
    if (!picker) return;
    const selected = Array.from(picker.querySelectorAll('.product-form__input')).map(group =>
      group.querySelector('select')?.value ?? group.querySelector('input:checked')?.value
    );
    const variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
    const variant = variants.find(v => v.options.every((val, i) => val === selected[i]));
    if (!variant) return;
    for (const field of root.querySelectorAll('product-form[data-main="true"] .product-variant-id, form.installment [name=id]')) {
      field.value = String(variant.id);
    }
  }
  function syncEvent(event) {
    const root = event.target.closest('[id^="MainProduct-"]');
    if (root) syncSelection(root);
  }
  document.addEventListener('change', event => {
    if (event.target.closest('variant-selects')) syncEvent(event);
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest('product-form[data-main="true"] [type=submit]')) syncEvent(event);
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.closest('product-form[data-main="true"]')) syncEvent(event);
  }, true);

  class TypeGrid extends HTMLElement {
    async connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      const list = this.querySelector('.mp-type-list');
      if (list.children.length >= 4) return;
      const ids = new Set([this.dataset.current, ...Array.from(list.children, row => row.dataset.mpCard)]);
      try {
        const url = new URL(this.dataset.source, location.origin);
        url.searchParams.set('section_id', 'mp-related-type');
        const resp = await fetch(url);
        if (!resp.ok) return;
        const doc = new DOMParser().parseFromString(await resp.text(), 'text/html');
        for (const card of doc.querySelectorAll('[data-mp-candidates] [data-mp-card]')) {
          if (card.dataset.type !== this.dataset.type || ids.has(card.dataset.mpCard)) continue;
          ids.add(card.dataset.mpCard);
          list.append(document.importNode(card, true));
          if (list.children.length === 4) break;
        }
      } catch { /* Keep any cards already rendered by Shopify. */ }
      this.hidden = list.children.length === 0;
    }
  }
  customElements.define('mp-type-grid', TypeGrid);
})();
